(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dj-card-quantity-picker"] && !Shopify.designMode) return;
  try {
    (() => {
  let activeForm = null;
  function update(form, normalize = true) {
    const input = form.querySelector('.dj-card-quantity__input');
    const min = Number(input.min) || 1;
    const step = Number(input.step) || 1;
    const max = input.max ? Number(input.max) : Infinity;
    let value = Number(input.value);
    if (normalize) {
      if (!Number.isFinite(value) || value < min) value = min;
      value = min + Math.floor((Math.min(value, max) - min) / step) * step;
      input.value = String(value);
    }
    const busy = form.dataset.djCartBusy === 'true';
    input.readOnly = busy;
    form.querySelector('[data-dj-quantity-change="-1"]').disabled = busy || value <= min;
    form.querySelector('[data-dj-quantity-change="1"]').disabled = busy || value + step > max;
    const select = form.querySelector('.dj-card-quantity__size-select');
    if (select) {
      select.disabled = busy;
      const available = Array.from(select.options).filter(option => option.dataset.available === 'true');
      const index = available.findIndex(option => option.value === select.value);
      form.querySelector('[data-dj-size-step="-1"]').disabled = busy || index <= 0;
      form.querySelector('[data-dj-size-step="1"]').disabled = busy || index < 0 || index >= available.length - 1;
    }
  }
  function selectVariant(form, choice) {
    if (!choice || choice.dataset.available !== 'true' || form.dataset.djCartBusy === 'true') return;
    form.querySelector('[name="id"]').value = choice.value;
    form.querySelector('.dj-card-quantity__size-select').value = choice.value;
    form.querySelector('.dj-card-quantity__size-value').textContent = choice.dataset.label;
    const input = form.querySelector('.dj-card-quantity__input');
    input.min = choice.dataset.min || '1';
    input.step = choice.dataset.step || '1';
    if (choice.dataset.max) input.max = choice.dataset.max;
    else input.removeAttribute('max');
    const card = form.closest('.dj-product-card');
    const price = card.querySelector('.s1pr');
    if (price) {
      const current = price.querySelector(':scope > span');
      if (current) {
        current.textContent = choice.dataset.price;
        current.classList.toggle('overlay-sale', Boolean(choice.dataset.comparePrice));
      }
      let old = price.querySelector('.old-price');
      if (choice.dataset.comparePrice && !old) {
        old = document.createElement('span');
        old.className = 'old old-price';
        current.after(document.createTextNode(' '), old);
      }
      if (old) {
        old.textContent = choice.dataset.comparePrice || '';
        old.hidden = !choice.dataset.comparePrice;
      }
      const unit = price.querySelector('.overlay-theme');
      if (unit) unit.textContent = choice.dataset.unitPrice || '';
    }
    const badge = card.querySelector('dj-discount-badge');
    if (badge) {
      const percent = Number(choice.dataset.discount) || 0;
      badge.hidden = percent <= 0;
      badge.textContent = percent > 0 ? `−${percent}%` : '';
      if (percent > 0) badge.setAttribute('aria-label', `${badge.dataset.saleLabel} −${percent}%`);
      else badge.removeAttribute('aria-label');
    }
    update(form);
  }
  function close(form, restoreFocus = false) {
    if (!form) return;
    form.dataset.quantityOpen = 'false';
    form.querySelector('.dj-card-quantity__options').hidden = true;
    const buy = form.querySelector('.dj-card-quantity__buy');
    buy.setAttribute('aria-expanded', 'false');
    if (restoreFocus && buy.isConnected) buy.focus({ preventScroll: true });
    if (activeForm === form) activeForm = null;
  }
  function open(form) {
    if (activeForm && activeForm !== form) close(activeForm);
    const buy = form.querySelector('.dj-card-quantity__buy');
    if (buy.disabled) return;
    form.dispatchEvent(new CustomEvent('dj:cart-add-state', { bubbles: true, detail: { state: 'idle' } }));
    activeForm = form;
    form.dataset.quantityOpen = 'true';
    form.querySelector('.dj-card-quantity__options').hidden = false;
    buy.setAttribute('aria-expanded', 'true');
    const select = form.querySelector('.dj-card-quantity__size-select');
    if (select) {
      const value = select.value;
      if (select.closest('[data-linked-sizes="true"]') && !select.dataset.sorted) {
        const order = ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL'];
        const collator = new Intl.Collator(document.documentElement.lang || undefined, { numeric: true });
        const rank = label => order.indexOf(label.toUpperCase().split(/[\s/–-]/)[0]);
        Array.from(select.options).sort((a, b) => {
          const left = rank(a.dataset.label);
          const right = rank(b.dataset.label);
          if (left >= 0 && right >= 0 && left !== right) return left - right;
          return collator.compare(a.dataset.label, b.dataset.label);
        }).forEach(option => select.append(option));
        select.value = value;
        select.dataset.sorted = 'true';
      }
      const selected = select.selectedOptions[0];
      selectVariant(form, selected?.dataset.available === 'true' ? selected : Array.from(select.options).find(option => option.dataset.available === 'true'));
    }
    update(form);
  }
  document.addEventListener('submit', event => {
    const form = event.target.closest('form.dj-card-quantity');
    if (!form) return;
    if (form.dataset.quantityOpen !== 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      open(form);
      return;
    }
    update(form);
    if (form.dataset.djCartBusy === 'true' || !form.reportValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('click', event => {
    const form = event.target.closest('form.dj-card-quantity');
    if (!form) return;
    const buy = event.target.closest('.dj-card-quantity__buy');
    if (buy) {
      event.preventDefault();
      event.stopPropagation();
      if (buy.disabled || form.dataset.djCartBusy === 'true') return;
      if (form.dataset.quantityOpen === 'true') form.requestSubmit(buy);
      else open(form);
      return;
    }
    const sizeStep = event.target.closest('[data-dj-size-step]');
    if (sizeStep) {
      event.preventDefault();
      event.stopPropagation();
      if (sizeStep.disabled || form.dataset.djCartBusy === 'true') return;
      const select = form.querySelector('.dj-card-quantity__size-select');
      const available = Array.from(select.options).filter(option => option.dataset.available === 'true');
      const index = available.findIndex(option => option.value === select.value);
      selectVariant(form, available[index + Number(sizeStep.dataset.djSizeStep)]);
      return;
    }
    const stepper = event.target.closest('[data-dj-quantity-change]');
    if (stepper && form.dataset.djCartBusy !== 'true') {
      event.preventDefault();
      event.stopPropagation();
      const input = form.querySelector('.dj-card-quantity__input');
      update(form);
      input.value = Number(input.value) + Number(stepper.dataset.djQuantityChange) * (Number(input.step) || 1);
      update(form);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, true);
  document.addEventListener('change', event => {
    const form = event.target.closest('form.dj-card-quantity');
    if (!form) return;
    if (event.target.matches('.dj-card-quantity__size-select')) {
      selectVariant(form, event.target.selectedOptions[0]);
    }
    update(form);
  });
  document.addEventListener('pointerdown', event => {
    if (activeForm && !activeForm.contains(event.target)) close(activeForm);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && activeForm) close(activeForm, true);
  });
  document.addEventListener('dj:cart-add-state', event => {
    const form = event.target;
    if (!form.matches('form.dj-card-quantity')) return;
    if (event.detail.state === 'success') {
      const shouldRestore = form.contains(document.activeElement);
      close(form, shouldRestore);
      const input = form.querySelector('.dj-card-quantity__input');
      input.value = input.min || '1';
    }
    update(form);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dj-discount-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dj-discount-badge')) {
    customElements.define('dj-discount-badge', class extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.discounts || this.abort) return;
        this.discounts = JSON.parse(this.dataset.discounts);
        this.scope = this.closest('.dj-product-card, .m6pr');
        if (!this.scope) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.scope.addEventListener('change', event => {
          if (this.scope.matches('.dj-product-card') && event.target.matches('select[name="id"], input[name="id"]')) {
            this.updateDiscount(event.target.value);
          }
        }, options);
        window.addEventListener('themeVariantUpdated', () => {
          const selection = this.scope.querySelector('[data-current-variant]');
          if (selection) this.updateDiscount(selection.dataset.currentVariant);
        }, options);
      }
      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        this.abort = null;
      }
      updateDiscount(id) {
        if (!Object.prototype.hasOwnProperty.call(this.discounts, id)) return;
        const percent = this.discounts[id];
        this.hidden = percent <= 0;
        this.textContent = percent > 0 ? `−${percent}%` : '';
        if (percent > 0) {
          this.setAttribute('aria-label', `${this.dataset.saleLabel} −${percent}%`);
        } else {
          this.removeAttribute('aria-label');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dj-dog-cart-quick-add"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dj-dog-quick-add')) {
    customElements.define('dj-dog-quick-add', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.querySelector('form').addEventListener('submit', event => this.add(event));
      }
      async add(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.busy) return;
        this.busy = true;
        const form = event.currentTarget;
        const button = form.querySelector('button');
        const label = button.querySelector('[data-dog-add-label]');
        const originalLabel = label.textContent;
        const error = this.querySelector('[data-dog-add-error]');
        const drawer = this.closest('#cart');
        const sectionId = drawer.dataset.sectionId;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        label.textContent = this.dataset.loading;
        error.hidden = true;
        const root = window.Shopify?.routes?.root || '/';
        let added = false;
        try {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: 1 }], sections: [sectionId], sections_url: window.location.pathname }),
            signal: AbortSignal.timeout(15000)
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          added = true;
          if (window.ajaxCart?.load) {
            window.ajaxCart.load(result.sections?.[sectionId] ? result : false, true, false, !result.sections?.[sectionId]);
          } else {
            window.location.assign(root + 'cart');
          }
        } catch (failure) {
          if (added) {
            window.location.assign(root + 'cart');
            return;
          }
          error.textContent = failure.name === 'TimeoutError' ? this.dataset.error : failure.message || this.dataset.error;
          error.hidden = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          label.textContent = originalLabel;
          this.busy = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
